


























































import {
  Prop,
  Watch,
  Component,
  Vue
} from 'vue-property-decorator';
import LeaseItemEditStockItem, {
  ILeaseItemEditStockItem
} from '@/modules/LeaseItem/EditStockItem';
import {
  IStockItemList_Item
} from '@/modules/StockItem/List';
import User from '@/modules/User';
import LeaseEdit from '@/modules/Lease/Edit';

@Component
export default class EditStockItem extends Vue {
  @Prop() readonly isEdit ? : boolean;

  isBusy = true;
  stockItemSelectInvalidFeedback ? = null as string | null;
  leaseInfo: LeaseEdit | null = new LeaseEdit();
  leaseItem = new LeaseItemEditStockItem();

  get stockItem(): any {
    if (!this.leaseItem.StockItemId) return null;

    return {
      Id: this.leaseItem.StockItemId,
      ItemNumber: this.leaseItem.StockItemNumber,
      Name: this.leaseItem.Name
    };
  }

  set stockItem(si: any) {
    this.stockItemSelectInvalidFeedback = null;

    const newStockItem = si || {} as any;

    this.leaseItem.StockItemId = newStockItem.Id;
    this.leaseItem.StockItemNumber = newStockItem.ItemNumber;
    this.leaseItem.Name = newStockItem.Name || this.leaseItem.Name;
    this.leaseItem.Unit = newStockItem.Unit;
    this.leaseItem.UnitPrice = newStockItem.UnitPrice;
    this.leaseItem.VatId = newStockItem.DefaultVatId;
  }

  get referenceUser(): any {
    return { 
      Id: this.leaseItem.ReferenceUserId, 
      Text: this.leaseItem.ReferenceUserText 
    };
  }

  set referenceUser(r: any) {
    this.leaseItem.ReferenceUserId   = r?.Id;
    this.leaseItem.ReferenceUserText = r?.Text ?? '';
  }

  get netAmount() {
    const price = this.leaseItem.UnitPrice;
    return (price - (price * this.leaseItem.DiscountPercent / 100.0)).toFixed(2);
  }

  async onSubmit() {
    if (this.leaseItem.StockItemId === null) {
      this.stockItemSelectInvalidFeedback = this.$t('Please select stock item');

      return;
    }

    this.isBusy = true;
    await this.leaseItem.Save();
    this.isBusy = false;

    this.$router.push(`/Lease/${+this.$route.params.leaseId}/Items`);
  }

  async fetchData() {
    this.isBusy = true;

    this.leaseInfo = await LeaseEdit.Find(+this.$route.params.leaseId);

    if (this.isEdit) {
      this.leaseItem = await LeaseItemEditStockItem.Find(+this.$route.params.leaseItemId);
    } else {
      this.leaseItem.LeaseId = +this.$route.params.leaseId;

      this.leaseItem.ReferenceUserId   = this.leaseInfo!.NewItemReferenceUserId;
      this.leaseItem.ReferenceUserText = this.leaseInfo!.NewItemReferenceUserText;
    }

    this.isBusy = false;
  }

  async mounted() {
    await this.$nextTick();
    await this.fetchData();
  }
}
